export enum OpportunityView {
  TABLE = "table",
  BOARD = "board",
}
